/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import Datetime from 'react-datetime';
import * as profitLossService from '../services/profitLossService'
import * as transactionService from '../services/transactionService'
import * as apiUserService from '../services/apiUserService'
import "react-datetime/css/react-datetime.css"
import Currency from './sub_components/currency'
import SplashVideoScreenModal from './sub_components/splashVideoScreenModal';
import { casinoList, SHOWSPLASHVIDEOSCREENMODALCONFIG } from '../configs/casinoShowList';
import { AFFILIATE_LINK } from '../configs/api';
import DashboardDetailsModel from './sub_components/user/dashboardDetailsModel';

class Dashboard extends Component {
   constructor(props) {
      super(props);
      this.state = {
         user_id: "",
         totalPnl: "",
         totalCommission: "",
         totalBets: "",
         topWinMarkets: [],
         topLossMarkets: [],
         topWinPlayers: [],
         topLossPlayers: [],
         gamePlay: {},
         sportGamePlay: "sport",
         raceGamePlay: "race",
         casinoGamePlay: "99",
         otherGamePlay: "other",
         totalAmount: "",
         totalDeposite: "",
         totalWithdraw: "",
         toastMsg: "",
         toastType: "",
         userCount: {},
         isOverallUserCount: false,
         eventNameById: { "1": "Soccer", "2": "Tennis", "4": "Cricket", "400": "Kabaddi", "500": "Election", "7": "Horse Racing", "4339": "Greyhound Racing", "300": "Binary" },
         showSplashVideoScreenModal: false,
         affiliateCode: '',
         registeredUserCount: null,
         depositCount: null,
         firstDepositCount: null,
         withdrawalCount: null,
         affPnLCount: null,
         openPopup: null
      };
   }
   async componentDidMount() {
      const videoSplashScreenVisited = localStorage.getItem('videoSplashScreenVisited');
      if (!(!!videoSplashScreenVisited)) {
         this.setState({ showSplashVideoScreenModal: true })
      }
      let user_data = localStorage.getItem("tokenData")
      user_data = JSON.parse(user_data)
      if (!(!!user_data && !!user_data.sub)) {
         localStorage.clear();
         this.props.history.push("/auth")
      }
      this.setState({ user_id: user_data.sub, affiliateCode: user_data.affiliateCode })

      let weekDate = this.getMonday(new Date().setHours(0, 0, 0, 0));
      let curDate = new Date(weekDate.getTime() + 7 * 24 * 60 * 60 * 1000);
      this.setState({ to: curDate, from: weekDate },
         () => {
            // this.onLoadPnl();
            this.onLoadUserPnl();
            this.onLoadTransaction();
            this.onLoadRegisteredUser();
            this.onLoadDeposit();
            this.onLoadFirstDeposit();
            this.onLoadWithdrawal();
            this.onLoadAffPnL();
            // this.onLoadUserCount();
            // this.onLoadAffDashboardData();
         }
      )
   }

   onSubmit() {
      let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 31) {
         this.props.notify(" Date range must be 1 month. ", "error");
      }
      else {
         // this.onLoadPnl();
         this.onLoadUserPnl();
         this.onLoadTransaction();
         this.onLoadRegisteredUser();
         this.onLoadDeposit();
         this.onLoadWithdrawal();
         this.onLoadAffPnL();

         // this.onLoadUserCount();
         // this.onLoadAffDashboardData();
         // this.onLoadUserCount();
      }
   }

   getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
         diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
   }

   parseFilterBody() {
      // let body = {
      //    "user_id": this.state.user_id,
      //    "client_id": "",
      //    "from": new Date(this.state.from).toISOString(),
      //    "to": new Date(this.state.to).toISOString(),
      // }
      let body = {
         "affiliate_id": this.state.user_id,
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
      }
      body = this.clean(body);
      return body
   }

   onLoadPnl() {
      const self = this;
      let body = this.parseFilterBody()

      profitLossService.postProfitLoss(body).then((res) => {
         // if (res.isSuccess) {
         //    self.setState({
         //       totalCommission: res.commission
         //    })
         // } else {
         //    this.props.notify(res.exception.message, "error")
         // }
      })
   }

   onLoadUserPnl() {
      const self = this;
      let body = {
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
         "affiliate_id": this.state.user_id
      };//this.parseFilterBody()

      profitLossService.postUserProfitLoss(body).then((res) => {
         if (res.isSuccess) {
            self.setState({
               totalCommission: res.commission
            })
         } else {
            this.props.notify(res.message, "error")
         }
      })
   }

   onLoadTransaction() {
      const self = this;
      let body = {
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
         "affiliate_id": this.state.user_id,
      }; //this.parseFilterBody()

      transactionService.depositeWithdrawTotal(body).then((res) => {
         if (res.isSuccess) {
            self.setState({ totalDeposite: res.deposit, totalWithdraw: res.withdraw })
         } else {
            this.props.notify(res.message, "error")
         }
      })
   }

   

   onLoadRegisteredUser() {
      const self = this;
      let body = {
         "affiliate_id": this.state.user_id
      };//this.parseFilterBody()

      profitLossService.postRegisteredUser(body).then((res) => {
         if (res.isSuccess) {
            self.setState({
               registeredUserCount: !!res.data ? res.data: null
            })
         } else {
            this.props.notify(res.message, "error")
         }
      })
   }

   

   onLoadDeposit() {
      const self = this;
      let body = {
         "affiliate_id": this.state.user_id
      };//this.parseFilterBody()

      profitLossService.postDeposit(body).then((res) => {
         if (res.isSuccess) {
            self.setState({
               depositCount: !!res.data ? res.data: null
            })
         } else {
            this.props.notify(res.message, "error")
         }
      })
   }
   
   onLoadFirstDeposit() {
      const self = this;
      let body = {
         "affiliate_id": this.state.user_id
      };

      profitLossService.postFirstDeposit(body).then((res) => {
         if (res.isSuccess) {
            self.setState({
               firstDepositCount: !!res.data ? res.data: null
            })
         } else {
            this.props.notify(res.message, "error")
         }
      })
   }

   

   onLoadWithdrawal() {
      const self = this;
      let body = {
         "affiliate_id": this.state.user_id
      };//this.parseFilterBody()

      profitLossService.postWithdrawal(body).then((res) => {
         if (res.isSuccess) {
            self.setState({
               withdrawalCount: !!res.data ? res.data: null
            })
         } else {
            this.props.notify(res.message, "error")
         }
      })
   }

   

   onLoadAffPnL() {
      const self = this;
      let body = {
         "affiliate_id": this.state.user_id
      };//this.parseFilterBody()

      profitLossService.postAffPnL(body).then((res) => {
         if (res.isSuccess) {
            self.setState({
               affPnLCount: !!res.data ? res.data: null
            })
         } else {
            this.props.notify(res.message, "error")
         }
      })
   }

   onLoadAffDashboardData() {
      const self = this;
      let body = {
         "affiliate_id": this.state.user_id
      };//this.parseFilterBody()

      profitLossService.postAffDashboardData(body).then((res) => {
         if (res.isSuccess) {
            self.setState({
               depositCount: !!res.deposit_result ? res.deposit_result: null,
               withdrawalCount: !!res.withdraw_result ? res.withdraw_result: null,
               registeredUserCount: !!res.reg_user_result ? res.reg_user_result: null,
               affPnLCount: !!res.pnl_result ? res.pnl_result: null,
            })
         } else {
            this.props.notify(res.message, "error")
         }
      })
   }


   onLoadUserCount() {
      const self = this;
      let body = {
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
         "affiliate_id": this.state.user_id,
      }; //this.parseFilterBody()

      transactionService.userCountTotal(body).then((res) => {

         // if (res.isSuccess) {
         //    let countobj = {
         //       "Admin": { count: 0, overallCount: 0 },
         //       "SuperMaster": { count: 0, overallCount: 0 },
         //       "SubSuperMaster": { count: 0, overallCount: 0 },
         //       "Master": { count: 0, overallCount: 0 },
         //       "Client": { count: 0, overallCount: 0 },
         //    }

         //    for (const itm of res.all) {
         //       if (!!countobj[itm._id.role]) {
         //          countobj[itm._id.role].overallCount = itm.count;
         //       }
         //    }

         //    for (const itm of res.items) {
         //       if (!!countobj[itm._id.role]) {
         //          countobj[itm._id.role].count = itm.count;
         //       }
         //    }
         //    self.setState({ userCount: countobj })
         //    // totalUserCount: "",
         //    // userCount: [],
         //    //    self.setState({ totalDeposite: res.deposit, totalWithdraw: res.withdraw })
         // }
      })
   }

   resetForm() {
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ from: weekDate, to: curDate })
   }

   onDateTimeChange(name, e) {
      this.setState({ [name]: e._d })
   }

   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }

   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }

   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }


   hideSplashVideoScreenModal() {
      this.setState({ showSplashVideoScreenModal: false });
   }

   copyToClipboard(content) {
      navigator.clipboard.writeText(content);
      this.props.notify('Copied', 'info');
   }

   openDetailsModal(dt){
      this.setState({openPopup:dt})
   }
   render() {
      return (
         <body className="bethubs dahboardhead">
            <Header history={this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0 dashboardmain">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <h5 className="text-blue">Dashboard</h5>
                     </div>
                     <div className="col-12 col-sm-12 col-md-8 col-lg-8 aff_link1">
                        <div className="referral-code">
                           {
                              !!this.state.affiliateCode &&
                              <>
                                 <label>Your Affiliate Url:</label>
                                 <div className="code-copy"><span className="ic-link"></span>
                                    <input className="form-control" readOnly="readonly" type="text" value={`${AFFILIATE_LINK}${this.state.affiliateCode}`} id="defaultLink" />
                                    <button className="btn-copy" onClick={() => this.copyToClipboard(`${AFFILIATE_LINK}${this.state.affiliateCode}`)} ></button>
                                    {/* <div className="tips-txt">Copied</div> */}
                                 </div>

                              </>
                           }
                        </div>
                     </div>
                     {/* <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <span className='f-right aff_link_font'>
                           <span className='mr-2 mb-1 text-danger aff_link_name'>Your Affiliate Url:</span>
                           <span className='aff_link'><a href='#'>{AFFILIATE_LINK}auth/{this.state.affiliateCode}</a></span>
                           <i className='fa fa-copy cursor-pointer pl-2' title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard()}></i>
                        </span>
                     </div> */}
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-2">
                        <div className='card'>
                           <div className='row p-2'>

                              {/* <div className='card-header'>sdssd</div> */}
                              <div className="col-6 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <label htmlFor="email">From Date:</label>
                                    <Datetime
                                       value={this.state.from}
                                       onChange={(e) => this.onDateTimeChange("from", e)}
                                       id="from_datetime"
                                       dateFormat={"DD/MM/YYYY"}
                                       timeFormat={"HH:mm"}
                                    />
                                 </div>
                              </div>
                              <div className="col-6 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <label htmlFor="email">To Date:</label>
                                    <Datetime
                                       value={this.state.to}
                                       onChange={(e) => this.onDateTimeChange("to", e)}
                                       id="to_datetime"
                                       dateFormat={"DD/MM/YYYY"}
                                       timeFormat={"HH:mm"}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                 <div className="btn-group mt-2_5" role="group" aria-label="Basic example">
                                    <button className="btn btn-blue" onClick={() => { this.onSubmit() }}>Submit</button>
                                    <button className="btn btn-danger ml-1" onClick={() => { this.resetForm() }}>Reset</button>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-5 col-xl-5">
                                 <div className="align-content-center d-flex justify-content-center" >
                                    {/* <div className='font-16 font-weight-bold mr-3 text-right w-40'>Commission:</div>
                                    <div className='w-60'>
                                       <div className='font-weight-bold font-12'>This Period <span className='ml-2 text-success'>0.00</span></div>
                                       <div className='font-weight-bold font-12'>Last Period <span className='ml-2 text-success'>0.00</span></div>
                                    </div> */}

                                 </div>
                              </div>

                           </div>
                        </div>
                        {/* <div className="main-box">
                           
                           
                        </div> */}
                     </div>
                  </div>
                  <div className='row mt-3 text-black box-pad-none'>
                     {/* <div className='col-6 col-lg-4 col-md-4 col-sm-6 col-xl-2 mb-3 paddingr-5'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">P&amp;L</h4>
                           </div>
                           <div className='card-body'>
                              <div className='d-flex'>
                                 <div className=''>
                                    <h2 className="mb-0 number-font"><Currency key={"pnl_total_wwekly"} amount={!!this.state.totalPnl ? this.state.totalPnl : 0} isOnlyNumber={true} showColor={true} /></h2>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div> */}
                     {/* <div className='col-12 col-lg-4 col-md-4 col-sm-6 col-xl-4 mb-3'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">Commission</h4>
                           </div>
                           <div className='card-body'>
                              <div className='d-flex'>
                                 <div className=''>
                                    <h2 className="mb-0 number-font "><Currency key={"commission_total_weekly"} amount={!!this.state.totalCommission ? this.state.totalCommission : 0} isOnlyNumber={true} showColor={true} /></h2>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div> */}
                     <div className='col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 mb-3'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">Deposit</h4>
                           </div>
                           <div className='card-body'>
                              <div className='d-flex'>
                                 <div className=''>
                                    <h2 className="mb-0 number-font text-black text-success"><Currency key={"deposite_total_weekly"} amount={!!this.state.totalDeposite ? this.state.totalDeposite : 0} isOnlyNumber={true} showColor={true} /></h2>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className='col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 mb-3'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">Withdrawal</h4>
                           </div>
                           <div className='card-body'>
                              <div className='d-flex'>
                                 <div className=''>
                                    <h2 className="mb-0 number-font text-black text-success"><Currency key={"withdraw_total_weekly"} amount={!!this.state.totalWithdraw ? this.state.totalWithdraw : 0} isOnlyNumber={true} showColor={true} /></h2>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     {/* <div className='col-6 col-lg-4 col-md-4 col-sm-6 col-xl-2 mb-3 paddingr-5'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">Total Bets</h4>
                           </div>
                           <div className='card-body'>
                              <div className='d-flex'>
                                 <div className=''>
                                    <h2 className="mb-0 number-font text-black">{!!this.state.totalBets ? this.state.totalBets : 0}</h2>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div> */}
                     {/* <div className='col-6 col-lg-4 col-md-4 col-sm-6 col-xl-2 mb-3 paddingl-5'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">SportBook P&amp;L</h4>
                           </div>
                           <div className='card-body'>
                              <div className='d-flex'>
                                 <div className=''>
                                    <h2 className="mb-0 number-font text-black"><Currency key={"sportbook_pnl"} amount={!!this.state.gamePlay["999"] && !!this.state.gamePlay["999"].totalPnl ? this.state.gamePlay["999"].totalPnl : 0} isOnlyNumber={true} showColor={true} /></h2>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div> */}
                  </div>

                  <div className='row'>
                     <div className='col-lg-4 col-md-6 col-sm-6 col-xl-4 mb-3'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">Registered Users</h4>
                           </div>
                           <div className='card-body p-0'>
                              <div className='table-responsive'>
                                 <table className="table font-12 table-bordered table-sm addpadding table-striped mt-0 mb-0">
                                    <thead className="thead-light">
                                       <tr>
                                          <th>Period</th>
                                          <th>Count</th>

                                       </tr>
                                    </thead>
                                    <tbody>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'register', range: 'today'})}>Today</td>
                                          <td id="count_5_1">{!!this.state.registeredUserCount && !!this.state.registeredUserCount.today_reg_user_count ? this.state.registeredUserCount.today_reg_user_count : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'register', range: 'yesterday'})}>Yesterday</td>
                                          <td id="count_5_2">{!!this.state.registeredUserCount && !!this.state.registeredUserCount.yesterday_reg_user_count ? this.state.registeredUserCount.yesterday_reg_user_count : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'register', range: 'thisWeek'})}>This Week</td>
                                          <td id="count_5_3">{!!this.state.registeredUserCount && !!this.state.registeredUserCount.this_week_reg_user_count ? this.state.registeredUserCount.this_week_reg_user_count : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'register', range: 'lastWeek'})}>Last Week</td>
                                          <td id="count_5_4">{!!this.state.registeredUserCount && !!this.state.registeredUserCount.last_week_reg_user_count ? this.state.registeredUserCount.last_week_reg_user_count : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'register', range: 'thisMonth'})}>This Month</td>
                                          <td id="count_5_5">{!!this.state.registeredUserCount && !!this.state.registeredUserCount.this_month_reg_user_count ? this.state.registeredUserCount.this_month_reg_user_count : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'register', range: 'lastMonth'})}>Last Month</td>
                                          <td id="count_5_6">{!!this.state.registeredUserCount && !!this.state.registeredUserCount.last_month_reg_user_count ? this.state.registeredUserCount.last_month_reg_user_count : 0}</td>

                                       </tr>

                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className='col-lg-4 col-md-6 col-sm-6 col-xl-4 mb-3'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">First Deposit</h4>
                           </div>
                           <div className='card-body p-0'>
                              <div className='table-responsive'>
                                 <table className="table font-12 table-bordered table-sm addpadding table-striped mt-0 mb-0">
                                    <thead className="thead-light">
                                       <tr>
                                          <th>Period</th>
                                          <th>Count</th>

                                          <th>Amount</th>

                                       </tr>
                                    </thead>
                                    <tbody>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'firstDeposit', range: 'today'})}>Today</td>
                                          <td id="count_2_1">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.today_first_deposit_count ? this.state.firstDepositCount.today_first_deposit_count : 0}</td>

                                          <td id="amount_2_1">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.today_first_deposit_amount ? this.state.firstDepositCount.today_first_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'firstDeposit', range: 'yesterday'})}>Yesterday</td>
                                          <td id="count_2_2">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.yesterday_first_deposit_count ? this.state.firstDepositCount.yesterday_first_deposit_count : 0}</td>

                                          <td id="amount_2_2">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.yesterday_first_deposit_amount ? this.state.firstDepositCount.yesterday_first_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'firstDeposit', range: 'thisWeek'})}>This Week</td>
                                          <td id="count_2_3">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.this_week_first_deposit_count ? this.state.firstDepositCount.this_week_first_deposit_count : 0}</td>

                                          <td id="amount_2_3">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.this_week_first_deposit_amount ? this.state.firstDepositCount.this_week_first_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'firstDeposit', range: 'lastWeek'})}>Last Week</td>
                                          <td id="count_2_4">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.last_week_first_deposit_count ? this.state.firstDepositCount.last_week_first_deposit_count : 0}</td>

                                          <td id="amount_2_4">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.last_week_first_deposit_amount ? this.state.firstDepositCount.last_week_first_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'firstDeposit', range: 'thisMonth'})}>This Month</td>
                                          <td id="count_2_5">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.this_month_first_deposit_count ? this.state.firstDepositCount.this_month_first_deposit_count : 0}</td>

                                          <td id="amount_2_5">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.this_month_first_deposit_amount ? this.state.firstDepositCount.this_month_first_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'firstDeposit', range: 'lastMonth'})}>Last Month</td>
                                          <td id="count_2_6">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.last_month_first_deposit_count ? this.state.firstDepositCount.last_month_first_deposit_count : 0}</td>

                                          <td id="amount_2_6">{!!this.state.firstDepositCount && !!this.state.firstDepositCount.last_month_first_deposit_amount ? this.state.firstDepositCount.last_month_first_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className='col-lg-4 col-md-6 col-sm-6 col-xl-4 mb-3'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">Deposit</h4>
                           </div>
                           <div className='card-body p-0'>
                              <div className='table-responsive'>
                                 <table className="table font-12 table-bordered table-sm addpadding table-striped mt-0 mb-0">
                                    <thead className="thead-light">
                                       <tr>
                                          <th>Period</th>
                                          <th>Count</th>

                                          <th>Amount</th>

                                       </tr>
                                    </thead>
                                    <tbody>

                                       <tr>
                                          <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'depo', range: 'today'})}>Today</td>
                                          <td id="count_2_1">{!!this.state.depositCount && !!this.state.depositCount.today_count ? this.state.depositCount.today_count : 0}</td>

                                          <td id="amount_2_1">{!!this.state.depositCount && !!this.state.depositCount.today_deposit_amount ? this.state.depositCount.today_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                       <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'depo', range: 'yesterday'})}>Yesterday</td>
                                          <td id="count_2_2">{!!this.state.depositCount && !!this.state.depositCount.yesterday_count ? this.state.depositCount.yesterday_count : 0}</td>

                                          <td id="amount_2_2">{!!this.state.depositCount && !!this.state.depositCount.yesterday_deposit_amount ? this.state.depositCount.yesterday_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                       <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'depo', range: 'thisWeek'})}>This Week</td>
                                          <td id="count_2_3">{!!this.state.depositCount && !!this.state.depositCount.this_week_count ? this.state.depositCount.this_week_count : 0}</td>

                                          <td id="amount_2_3">{!!this.state.depositCount && !!this.state.depositCount.this_week_deposit_amount ? this.state.depositCount.this_week_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                       <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'depo', range: 'lastWeek'})}>Last Week</td>
                                          <td id="count_2_4">{!!this.state.depositCount && !!this.state.depositCount.last_week_count ? this.state.depositCount.last_week_count : 0}</td>

                                          <td id="amount_2_4">{!!this.state.depositCount && !!this.state.depositCount.last_week_deposit_amount ? this.state.depositCount.last_week_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                       <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'depo', range: 'thisMonth'})}>This Month</td>
                                          <td id="count_2_5">{!!this.state.depositCount && !!this.state.depositCount.this_month_count ? this.state.depositCount.this_month_count : 0}</td>

                                          <td id="amount_2_5">{!!this.state.depositCount && !!this.state.depositCount.this_month_deposit_amount ? this.state.depositCount.this_month_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                       <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'depo', range: 'lastMonth'})}>Last Month</td>
                                          <td id="count_2_6">{!!this.state.depositCount && !!this.state.depositCount.last_month_count ? this.state.depositCount.last_month_count : 0}</td>

                                          <td id="amount_2_6">{!!this.state.depositCount && !!this.state.depositCount.last_month_deposit_amount ? this.state.depositCount.last_month_deposit_amount.toFixed(2) : 0}</td>

                                       </tr>

                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>
                     </div>


                     <div className='col-lg-4 col-md-6 col-sm-6 col-xl-4 mb-3'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">Withdrawal</h4>
                           </div>
                           <div className='card-body p-0'>
                              <div className='table-responsive'>
                                 <table className="table font-12 table-bordered table-sm addpadding table-striped mt-0 mb-0">
                                    <thead className="thead-light">
                                       <tr>
                                          <th>Period</th>
                                          <th>Count</th>

                                          <th>Amount</th>

                                       </tr>
                                    </thead>
                                    <tbody>

                                    <tr>
                                    <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'with', range: 'today'})}>Today</td>
                                          <td id="count_2_1">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.today_count ? this.state.withdrawalCount.today_count : 0}</td>

                                          <td id="amount_2_1">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.today_withdraw_amount ? this.state.withdrawalCount.today_withdraw_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                       <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'with', range: 'yesterday'})}>Yesterday</td>
                                          <td id="count_2_2">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.yesterday_count ? this.state.withdrawalCount.yesterday_count : 0}</td>

                                          <td id="amount_2_2">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.yesterday_withdraw_amount ? this.state.withdrawalCount.yesterday_withdraw_amount.toFixed(2): 0}</td>

                                       </tr>

                                       <tr>
                                       <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'with', range: 'thisWeek'})}>This Week</td>
                                          <td id="count_2_3">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.this_week_count ? this.state.withdrawalCount.this_week_count : 0}</td>

                                          <td id="amount_2_3">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.this_week_withdraw_amount ? this.state.withdrawalCount.this_week_withdraw_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                       <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'with', range: 'lastWeek'})}>Last Week</td>
                                          <td id="count_2_4">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.last_week_count ? this.state.withdrawalCount.last_week_count : 0}</td>

                                          <td id="amount_2_4">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.last_week_withdraw_amount ? this.state.withdrawalCount.last_week_withdraw_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                       <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'with', range: 'thisMonth'})}>This Month</td>
                                          <td id="count_2_5">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.this_month_count ? this.state.withdrawalCount.this_month_count : 0}</td>

                                          <td id="amount_2_5">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.this_month_withdraw_amount ? this.state.withdrawalCount.this_month_withdraw_amount.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                       <td className="align-center cursor-pointer undline" onClick={()=> this.openDetailsModal({type: 'with', range: 'lastMonth'})}>Last Month</td>
                                          <td id="count_2_6">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.last_month_count ? this.state.withdrawalCount.last_month_count : 0}</td>

                                          <td id="amount_2_6">{!!this.state.withdrawalCount && !!this.state.withdrawalCount.last_month_withdraw_amount ? this.state.withdrawalCount.last_month_withdraw_amount.toFixed(2) : 0}</td>

                                       </tr>

                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className='col-lg-4 col-md-6 col-sm-6 col-xl-4 mb-3'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">Turnover</h4>
                           </div>
                           <div className='card-body p-0'>
                              <div className='table-responsive'>
                                 <table className="table font-12 table-bordered table-sm addpadding table-striped mt-0 mb-0">
                                    <thead className="thead-light">
                                       <tr>
                                          <th>Period</th>
                                          <th>Count</th>

                                          <th>Amount</th>

                                       </tr>
                                    </thead>
                                    <tbody>

                                       <tr>
                                          <td className="align-center">Today</td>
                                          <td id="count_2_1">0</td>

                                          <td id="amount_2_1">0.00</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">Yesterday</td>
                                          <td id="count_2_2">0</td>

                                          <td id="amount_2_2">0.00</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">This Week</td>
                                          <td id="count_2_3">0</td>

                                          <td id="amount_2_3">0.00</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">Last Week</td>
                                          <td id="count_2_4">0</td>

                                          <td id="amount_2_4">0.00</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">This Month</td>
                                          <td id="count_2_5">0</td>

                                          <td id="amount_2_5">0.00</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">Last Month</td>
                                          <td id="count_2_6">0</td>

                                          <td id="amount_2_6">0.00</td>

                                       </tr>

                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className='col-lg-4 col-md-6 col-sm-6 col-xl-4 mb-3'>
                        <div className='card overflow-hidden'>
                           <div className="card-header">
                              <h4 className="card-title fw-semibold">Affiliate Profit & Loss</h4>
                           </div>
                           <div className='card-body p-0'>
                              <div className='table-responsive'>
                                 <table className="table font-12 table-bordered table-sm addpadding table-striped mt-0 mb-0">
                                    <thead className="thead-light">
                                       <tr>
                                          <th>Period</th>
                                          {/* <th>Count</th> */}

                                          <th>Amount</th>

                                       </tr>
                                    </thead>
                                    <tbody>

                                    <tr>
                                          <td className="align-center">Today</td>
                                          <td id="count_5_1">{!!this.state.affPnLCount && !!this.state.affPnLCount.today_pnl ? this.state.affPnLCount.today_pnl.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">Yesterday</td>
                                          <td id="count_5_2">{!!this.state.affPnLCount && !!this.state.affPnLCount.yesterday_pnl ? this.state.affPnLCount.yesterday_pnl.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">This Week</td>
                                          <td id="count_5_3">{!!this.state.affPnLCount && !!this.state.affPnLCount.this_week_pnl ? this.state.affPnLCount.this_week_pnl.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">Last Week</td>
                                          <td id="count_5_4">{!!this.state.affPnLCount && !!this.state.affPnLCount.last_week_pnl ? this.state.affPnLCount.last_week_pnl.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">This Month</td>
                                          <td id="count_5_5">{!!this.state.affPnLCount && !!this.state.affPnLCount.this_month_pnl ? this.state.affPnLCount.this_month_pnl.toFixed(2) : 0}</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">Last Month</td>
                                          <td id="count_5_6">{!!this.state.affPnLCount && !!this.state.affPnLCount.last_month_pnl ? this.state.affPnLCount.last_month_pnl.toFixed(2) : 0}</td>

                                       </tr>

                                       {/* <tr>
                                          <td className="align-center">Today</td>
                                          <td id="count_2_1">0</td>

                                          <td id="amount_2_1">0.00</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">Yesterday</td>
                                          <td id="count_2_2">0</td>

                                          <td id="amount_2_2">0.00</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">This Week</td>
                                          <td id="count_2_3">0</td>

                                          <td id="amount_2_3">0.00</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">Last Week</td>
                                          <td id="count_2_4">0</td>

                                          <td id="amount_2_4">0.00</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">This Month</td>
                                          <td id="count_2_5">0</td>

                                          <td id="amount_2_5">0.00</td>

                                       </tr>

                                       <tr>
                                          <td className="align-center">Last Month</td>
                                          <td id="count_2_6">0</td>

                                          <td id="amount_2_6">0.00</td>

                                       </tr> */}

                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>
                     </div>

                  </div>

               </div>
            </div>
            {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
            <Footer />
            {SHOWSPLASHVIDEOSCREENMODALCONFIG && this.state.showSplashVideoScreenModal && <SplashVideoScreenModal hidePopup={() => { this.hideSplashVideoScreenModal() }} />}
            
            {!!this.state.openPopup && <DashboardDetailsModel dataOf={this.state.openPopup} closePopup={() => { this.setState({ "openPopup": null }) }} />}
         </body>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);